export const Contracts = {
    ExpertFinanceiro: {
        Modules: {
            Dashboards: {
                contracted: true,
                sources: ["fin"],
                hide: true
            },
            CustomVarsIndicatorsCharts: {
                contracted: false,
                sources: ["fin"],
                hide: true
            },
            DashboardsCustomization: {
                contracted: true,
                sources: ["fin"],
                hide: true
            },
            Reports: {
                contracted: true,
                sources: ["fin"],
                hide: true
            },
            MonitoringPortfolio: {
                contracted: true,
                sources: ["fin"],
                hide: true
            },
            MonitoringCompany: {
                contracted: true,
                sources: ["fin"],
                hide: true
            },
            MonitoringConfig: {
                contracted: true,
                sources: ["fin"],
                hide: true
            },
            Demonstrations: {
                contracted: true,
                sources: ["fin"],
                hide: true
            },
            DepartmentsImport: {
                contracted: true,
                sources: ["fin"],
                hide: true
            },
            Integrations: {
                contracted: true,
                sources: ["fin"],
                hide: true
            },
            BatchImport: {
                contracted: true,
                sources: ["fin"],
                hide: true
            },
            CompaniesTable: { contracted: true, sources: ["fin"], hide: true }
        },
        Features: {
            Themes: { contracted: true },
            Groups: { contracted: true },
            Score: { contracted: true }
        }
    },
    Expert: {
        Modules: {
            Dashboards: {
                contracted: true,
                sources: ["accounting", "fin", "personnel", "tax"]
            },
            CustomVarsIndicatorsCharts: {
                contracted: true,
                sources: ["accounting", "fin", "personnel", "tax"]
            },
            DashboardsCustomization: {
                contracted: true,
                sources: ["accounting", "fin", "personnel", "tax"]
            },
            Reports: {
                contracted: true,
                sources: ["accounting", "fin", "personnel", "tax"]
            },
            MonitoringPortfolio: {
                contracted: true,
                sources: [
                    "accounting",
                    "fin",
                    "personnel",
                    "eSocial",
                    "tax",
                    "simplesNacional"
                ]
            },
            MonitoringCompany: {
                contracted: true,
                sources: [
                    "accounting",
                    "fin",
                    "personnel",
                    "eSocial",
                    "tax",
                    "simplesNacional"
                ]
            },
            MonitoringConfig: {
                contracted: true,
                sources: [
                    "accounting",
                    "fin",
                    "personnel",
                    "eSocial",
                    "tax",
                    "simplesNacional"
                ]
            },
            Demonstrations: {
                contracted: true,
                sources: ["accounting", "fin", "personnel", "tax"]
            },
            DepartmentsImport: {
                contracted: true,
                sources: ["accounting", "fin", "personnel", "tax"]
            },
            Integrations: {
                contracted: true,
                sources: ["accounting", "fin"]
            },
            BatchImport: {
                contracted: true,
                sources: ["fin", "personnel", "tax"]
            },
            CompaniesTable: {
                contracted: true,
                sources: ["accounting", "fin", "personnel", "tax"]
            }
        },
        Features: {
            Themes: { contracted: true },
            Groups: { contracted: true },
            Score: { contracted: true }
        }
    },
    Starter: {
        Modules: {
            Dashboards: {
                contracted: true,
                sources: ["fin", "personnel", "tax"]
            },
            CustomVarsIndicatorsCharts: {
                contracted: false,
                sources: ["fin", "personnel", "tax"]
            },
            DashboardsCustomization: {
                contracted: false,
                sources: ["fin", "personnel", "tax"]
            },
            Reports: {
                contracted: true,
                sources: ["fin", "personnel", "tax"]
            },
            MonitoringPortfolio: {
                contracted: true,
                sources: [
                    "fin",
                    "personnel",
                    "eSocial",
                    "tax",
                    "simplesNacional"
                ]
            },
            MonitoringCompany: {
                contracted: true,
                sources: [
                    "fin",
                    "personnel",
                    "eSocial",
                    "tax",
                    "simplesNacional"
                ]
            },
            MonitoringConfig: {
                contracted: true,
                sources: [
                    "fin",
                    "personnel",
                    "eSocial",
                    "tax",
                    "simplesNacional"
                ]
            },
            Demonstrations: {
                contracted: true,
                sources: ["fin", "personnel", "tax"]
            },
            DepartmentsImport: {
                contracted: true,
                sources: ["fin", "personnel", "tax"]
            },
            Integrations: {
                contracted: true,
                sources: ["fin"]
            },
            BatchImport: {
                contracted: true,
                sources: ["fin", "personnel", "tax"]
            },
            CompaniesTable: {
                contracted: true,
                sources: ["fin", "personnel", "tax"]
            }
        },
        Features: {
            Themes: { contracted: false },
            Groups: { contracted: false },
            Score: { contracted: true }
        }
    },
    Professional: {
        Modules: {
            Dashboards: {
                contracted: true,
                sources: ["accounting", "fin", "personnel", "tax"]
            },
            CustomVarsIndicatorsCharts: {
                contracted: true,
                sources: ["accounting", "fin", "personnel", "tax"]
            },
            DashboardsCustomization: {
                contracted: true,
                sources: ["accounting", "fin", "personnel", "tax"]
            },
            Reports: {
                contracted: true,
                sources: ["accounting", "fin", "personnel", "tax"]
            },
            MonitoringPortfolio: {
                contracted: true,
                sources: [
                    "accounting",
                    "fin",
                    "personnel",
                    "eSocial",
                    "tax",
                    "simplesNacional"
                ]
            },
            MonitoringCompany: {
                contracted: true,
                sources: [
                    "accounting",
                    "fin",
                    "personnel",
                    "tax",
                    "simplesNacional"
                ]
            },
            MonitoringConfig: {
                contracted: true,
                sources: [
                    "accounting",
                    "fin",
                    "personnel",
                    "eSocial",
                    "tax",
                    "simplesNacional"
                ]
            },
            Demonstrations: {
                contracted: true,
                sources: ["accounting", "fin", "personnel", "tax"]
            },
            DepartmentsImport: {
                contracted: true,
                sources: ["accounting", "fin", "personnel", "tax"]
            },
            Integrations: {
                contracted: true,
                sources: ["accounting", "fin"]
            },
            BatchImport: {
                contracted: true,
                sources: ["accounting", "fin", "personnel", "tax"]
            },
            CompaniesTable: {
                contracted: true,
                sources: ["accounting", "fin", "personnel", "tax"]
            }
        },
        Features: {
            Themes: { contracted: false },
            Groups: { contracted: false },
            Score: { contracted: true }
        }
    },
    Standard: {
        Modules: {
            Dashboards: {
                contracted: true,
                sources: ["accounting", "fin", "personnel", "tax"]
            },
            CustomVarsIndicatorsCharts: {
                contracted: true,
                sources: ["accounting", "fin", "personnel", "tax"]
            },
            DashboardsCustomization: {
                contracted: true,
                sources: ["accounting", "fin", "personnel", "tax"]
            },
            Reports: {
                contracted: true,
                sources: ["accounting", "fin", "personnel", "tax"]
            },
            MonitoringPortfolio: {
                contracted: true,
                sources: [
                    "accounting",
                    "fin",
                    "personnel",
                    "eSocial",
                    "tax",
                    "simplesNacional"
                ]
            },
            MonitoringCompany: {
                contracted: true,
                sources: [
                    "accounting",
                    "fin",
                    "personnel",
                    "eSocial",
                    "tax",
                    "simplesNacional"
                ]
            },
            MonitoringConfig: {
                contracted: true,
                sources: [
                    "accounting",
                    "fin",
                    "personnel",
                    "eSocial",
                    "tax",
                    "simplesNacional"
                ]
            },
            Demonstrations: {
                contracted: true,
                sources: ["accounting", "fin", "personnel", "tax"]
            },
            DepartmentsImport: {
                contracted: true,
                sources: ["accounting", "fin", "personnel", "tax"]
            },
            Integrations: {
                contracted: true,
                sources: ["accounting", "fin"]
            },
            BatchImport: {
                contracted: true,
                sources: ["accounting", "fin", "personnel", "tax"]
            },
            CompaniesTable: {
                contracted: true,
                sources: ["accounting", "fin", "personnel", "tax"]
            }
        },
        Features: {
            Themes: { contracted: false },
            Groups: { contracted: false },
            Score: { contracted: false }
        }
    }
};
